module.exports = __webpack_public_path__ + "img/bg-magento-find-out_medium.1a60a75d.jpg";